import React from 'react';
import { Order } from '../../../types';
import OrderCard from './OrderCard';

interface OrderListProps {
  orders: Order[];
  loading: boolean;
  error: string | null;
  onActionClick: (orderId: number, action: string) => void;
}

const OrderList: React.FC<OrderListProps> = ({ orders, loading, error, onActionClick }) => {
  return (
    <div className="bg-white rounded-lg">
      {loading && (
        <p className="text-gray-600 p-4" aria-live="polite">
          Loading orders...
        </p>
      )}
      {error && (
        <p className="text-red-600 bg-red-50 p-4 rounded border border-red-200" role="alert">
          {error}
        </p>
      )}
      {!loading && !error && orders.length === 0 && (
        <p className="text-gray-600 p-4">No orders available.</p>
      )}
      {!loading && !error && orders.length > 0 && (
        <div className="space-y-4">
          {orders.map((order) => (
            <OrderCard
              key={order.id}
              order={order}

              onActionClick={(action) => onActionClick(order.id, action)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default OrderList;